import React from 'react'
import { withRouter, Switch, Route } from 'react-router-dom'
import App from './app'

/**
 * The RouterApp is a lightweight wrapper on the router which contains routes that the entire app supports.
 * The client needs to load the same html the server sends out.
 * In particular, the html for the router is constructed differently on the server, thus this container is rendered by the client (src/client/index)
 * The server does not use this container because it matches the routes directly before it renders the html.
 *
 * NOTE: THE REGEX MATCHING HERE IS DIFFERENT FROM OUR SERVER BECAUSE OF WHAT REACT ROUTER SUPPORTS
 *
 */
const Router = ({ ssrHints }) => (
  <Switch>
    <Route
      path=':address(.+)-(p)?:resourceId(\d+)'
      render={props => <App {...props} ssrHints={ssrHints} />}
    />
  </Switch>
)

export default withRouter(Router)
